import React from "react";

export default function MySQL_CAST() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_CAST</h1>
      <p>This is the MySQL_CAST component generated from the SQL JSON.</p>
    </div>
  );
}
